import { render, staticRenderFns } from "./VTabsWithAnimationMTS.vue?vue&type=template&id=394afd41&scoped=true"
import script from "./VTabsWithAnimationMTS.vue?vue&type=script&lang=js"
export * from "./VTabsWithAnimationMTS.vue?vue&type=script&lang=js"
import style0 from "./VTabsWithAnimationMTS.vue?vue&type=style&index=0&id=394afd41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394afd41",
  null
  
)

export default component.exports